/**
 * YouTube 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <YoutubeIcon className="w-8 h-8" />
 * <YoutubeIcon className="w-12 h-12" />
 * ```
 */
export function YoutubeIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="YouTube icon"
      role="img"
    >
      <title>YouTube</title>
      <g id="Youtube">
        <path
          id="Vector"
          d="M13.2 20.2857L20.466 16L13.2 11.7143V20.2857ZM29.384 9.1C29.566 9.77143 29.692 10.6714 29.776 11.8143C29.874 12.9571 29.916 13.9429 29.916 14.8L30 16C30 19.1286 29.776 21.4286 29.384 22.9C29.034 24.1857 28.222 25.0143 26.962 25.3714C26.304 25.5571 25.1 25.6857 23.252 25.7714C21.432 25.8714 19.766 25.9143 18.226 25.9143L16 26C10.134 26 6.48 25.7714 5.038 25.3714C3.778 25.0143 2.966 24.1857 2.616 22.9C2.434 22.2286 2.308 21.3286 2.224 20.1857C2.126 19.0429 2.084 18.0571 2.084 17.2L2 16C2 12.8714 2.224 10.5714 2.616 9.1C2.966 7.81429 3.778 6.98571 5.038 6.62857C5.696 6.44286 6.9 6.31429 8.748 6.22857C10.568 6.12857 12.234 6.08571 13.774 6.08571L16 6C21.866 6 25.52 6.22857 26.962 6.62857C28.222 6.98571 29.034 7.81429 29.384 9.1Z"
          fill="#FF0034"
        />
      </g>
    </svg>
  );
}
